module.exports = __webpack_public_path__ + "img/excel.d67d3e6.png";